import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  OnDestroy,
  Signal,
  viewChild,
} from '@angular/core';
import {
  EControlActions,
  FormControlService,
  IApiControl,
  IControlObject,
} from 'frontier/nucleus';
import {BehaviorSubject, combineLatest, filter, mergeMap, Observable, of, Subscription, tap} from 'rxjs';
import {FormControl} from '@angular/forms';
import {ICheckboxFormElement, ISelectFormElement, ITextFormElement} from 'frontier/browserkit';
import {GuidFormControlComponent} from './guid-form-control/guid-form-control.component';
import {ControlStore} from 'frontier/nucleus/src/lib/apiv2/control.store';
import {
  FormWrapperComponent
} from '../../components/control/form-control/dynamic-form/form-wrapper/form-wrapper.component';
import {
  TextElementComponent
} from '../../components/control/form-control/dynamic-form/form-element/text-element/text-element.component';
import {
  CheckboxElementComponent
} from '../../components/control/form-control/dynamic-form/form-element/checkbox-element/checkbox-element.component';
import {GuidSearchBase} from '../guid-search.base';
import {MatAutocomplete} from '@angular/material/autocomplete';
import {MatOption} from '@angular/material/core';

@Component({
  selector: 'kpi4me-guid-form',
  templateUrl: './guid-form.component.html',
  styleUrls: ['./guid-form.component.scss'],
  standalone: true,
  imports: [
    CheckboxElementComponent,
    TextElementComponent,
    FormWrapperComponent,
    GuidFormControlComponent,
    MatAutocomplete,
    MatOption,
  ],
})
export class GuidFormComponent extends GuidSearchBase implements OnDestroy {
  private _controlStore: ControlStore = inject(ControlStore);
  private _formControlService: FormControlService = inject(FormControlService);

  formRef: Signal<GuidFormControlComponent> = viewChild(GuidFormControlComponent);

  hasRepo: FormControl<boolean> = new FormControl(false);
  formGuid: FormControl<string> = new FormControl('');
  repoSelectedElement: FormControl<any> = new FormControl(null);

  textElementData: ITextFormElement = {
    label: 'Formular selectionGUID',
    inputType: 'text',
    required: true
  };
  render: boolean = false;
  checkboxData: ICheckboxFormElement = {
    label: 'Mit Repository',
    value: true,
    displayAs: 'toggle'
  };
  repoSelectionData: ISelectFormElement = {
    label: 'Repository',
    options: [],
    createNewEnabled: true,
    multiple: false,
  };

  hasRepo$: BehaviorSubject<boolean> = new BehaviorSubject(this.hasRepo.value);
  initializedFormControl$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private formGuidChange$: EventEmitter<string> = new EventEmitter<string>();

  private subs: Subscription = new Subscription();

  constructor(
    protected cdr: ChangeDetectorRef,
  ) {
    super();
    this.subs.add(
      combineLatest([
        this.hasRepo$.pipe(filter((v: boolean): boolean => v == true)),
        this.initializedFormControl$.pipe(filter(v => v != null))
      ]).pipe(
        mergeMap((): Observable<any> => this.updateRepo(null))
      ).subscribe()
    );

    this.subs.add(
      this.formGuidChange$.subscribe((guid: string): void => {
        this.render = false;
        this.cdr.detectChanges();
        this.render = true;
        this.cdr.detectChanges();
        console.log('guid change', guid);
      })
    );

    this.subs.add(
      this.repoSelectedElement.valueChanges.subscribe(v => {
        if (v) {
          this.formRef().patchFilter({
            parent: v
          });
        }
      })
    );

    this.subs.add(
      this.formGuid.valueChanges.subscribe((value: string): void => {
        this.onGuidInputChanged(value);
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  protected applyGuidValue(value: string): void {
    this.formGuid.setValue(value, {emitEvent: false});
    this.formGuidChange$.emit(value);
  }

  onHasRepoChanged(b: boolean): void {
    console.log('has repo changed', b);
    this.hasRepo$.next(b);
  }

  updateRepo(action: EControlActions) {
    console.log('updating repo');
    if (this.hasRepo.value == false) {
      return of(null);
    } else {
      return this._formControlService.dBObjectFormControlGetRepository({
          InstanceId: this.formRef().instanceId()
        }
      ).pipe(
        tap((repository): void => {
          this.repoSelectionData = {
            ...this.repoSelectionData,
            ...repository,
            options: repository.options
          };
          if (action) {
            this._controlStore.controlDataChanged$.emit({GUID: this.formGuid.value, changeType: action});
          }
        })
      )
    }
  }

  onInizializedDynamicFormControl(event: IApiControl): void {
    console.log('Inizialized dynamic form control');
    this.initializedFormControl$.next(event)
  }

  onNewElement(): void {
    this._formControlService.dBObjectFormControlNewElement({
      InstanceId: this.formRef().instanceId(),
      formElements: null,
      name: null
    })
      .subscribe(res => {
        this.updateRepo(EControlActions.create).subscribe((): void => {
          this.repoSelectedElement.patchValue(res);
        })
      })
  }

  onDeleteElement(evt: IControlObject): void {
    this._formControlService.dBObjectFormControlDeleteElement({
      InstanceId: this.formRef().instanceId(),
      dbobject: evt
    })
      .subscribe((res: boolean): void => {
        this.updateRepo(EControlActions.delete).subscribe((): void => {
          if (res) {
            this.repoSelectedElement.patchValue(null);
          }
        })
      })
  }
}
